var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('div',[_c('tl-header',{attrs:{"type":"h1"}},[_c('div',{staticClass:"main-header"},[_vm._v("Manage Employee Documents")])])],1),_c('div',{staticClass:"margintop-16"},[_c('manageEmployeeDocuments')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }